import { Controller } from "@hotwired/stimulus"
import { newNameIn, restoreNewName } from "../helpers/combobox_new_name.js"

// A Field Task picker that accepts a name the Farm doesn't have (ADR 0090). A new name opens the panel asking for its
// unit and cost method (a jornal unit is paid per jornal), and the form hears new-field-task:change with the new
// task's cost meta, or null when an existing task is picked.
export default class extends Controller {
  static targets = ["panel", "name", "unit", "unitNameField", "unitName", "costMethod"]
  static values = { pending: Boolean }

  connect() {
    if (this.pendingValue) restoreNewName(this.element)
    this.update()
  }

  update() {
    const name = newNameIn(this.element)
    const option = this.unitTarget.selectedOptions[0]
    const newUnit = this.unitTarget.value === "new"
    const typedUnit = newUnit ? this.unitNameTarget.value.trim().toLowerCase() : ""
    // A typed jornal word is the jornal unit on the server (FieldTaskUnit.bind), so it is paid per jornal here too.
    const laborDay = newUnit ? this.#isJornalWord(typedUnit) : option?.dataset.laborDay === "true"

    this.panelTarget.classList.toggle("hidden", !name)
    this.nameTarget.textContent = name ? `«${name}»` : ""
    this.unitNameFieldTarget.classList.toggle("hidden", !newUnit)
    if (laborDay) this.costMethodTarget.value = "labor_unit"
    this.costMethodTarget.disabled = laborDay

    this.dispatch("change", {
      detail: name
        ? {
            costMethod: this.costMethodTarget.value,
            laborDay,
            unitOne: typedUnit || option?.dataset.unitOne,
            unitOther: typedUnit || option?.dataset.unitOther,
          }
        : null,
    })
  }

  #isJornalWord(word) {
    const words = JSON.parse(this.unitNameTarget.dataset.jornalWords || "[]")
    return words.includes(word.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
  }
}
